import { render, staticRenderFns } from "./LeaveAdminList.vue?vue&type=template&id=4af06b72"
import script from "./LeaveAdminList.ts?vue&type=script&lang=ts&external"
export * from "./LeaveAdminList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports